export const ProjectData = [
  {
    id: "latencywatch",
    title: "LatencyWatch | Python",
    description: "A lightweight Python profiler for tracing nested function-call latencies and self-times with minimal overhead.",
    skills: ["Python", "sys.setprofile", "Threading", "Decorators"],
    details: [
      "Built a lightweight Python profiler using sys.setprofile to trace nested function-call latencies and self-times with minimal overhead.",
      "Designed a threaded, decorator-based tracing system with structured reports to identify performance bottlenecks in real-time applications."
    ],
    githubLink: "https://github.com/NAGARAJ08/latencywatch"
  },
  {
    id: "kafka-replay",
    title: "Kafka-Replay Tool | Python",
    description: "A CLI tool to retrieve Kafka messages by timestamp, translating time ranges into offset-based fetches using the Kafka consumer API.",
    skills: ["Python", "Apache Kafka", "CLI"],
    details: [
      "Developed a CLI tool to retrieve Kafka messages by timestamp, translating time ranges into offset-based fetches using the Kafka consumer API.",
      "Enhanced operational debugging by supporting topic, partition, and time-based replay with seamless multi-partition compatibility."
    ],
    githubLink: "https://github.com/NAGARAJ08/kafka-replay"
  },
  {
    id: "transit-tracker",
    title: "TransitTracker - Real-time Bus Tracking System",
    description: "A real-time bus tracking system designed to monitor and predict bus locations and provide estimated arrival times within urban areas.",
    skills: ["Python", "Apache Kafka", "Distributed Systems", "MongoDB"],
    details: [
      "Developed a backend using FastAPI to handle HTTP requests and communicate with MongoDB for data storage.",
      "Used Kafka to manage high-throughput real-time data streams between system components.",
      "Created a GPS data simulator to simulate bus movement and publish data to Kafka.",
      "Implemented an ETA processor to calculate and store estimated arrival times.",
      "Built a simple HTML/CSS/JavaScript frontend for real-time information."
    ],
    challenges: "Handling real-time data stream processing and ensuring data integrity while managing multiple components that interact with Kafka.",
    impact: "Gained hands-on experience with Kafka for real-time data streaming and integrating it with FastAPI and MongoDB.",
    githubLink: "https://github.com/NAGARAJ08/TransitTracker"
  },
  {
    id: "segmentation-tranverse",
    title: "Segmentation Of The Transverse Section Of The Carotid Artery using U-Net",
    description: "An automated segmentation model for the common carotid artery using transverse section ultrasound images.",
    skills: ["Python", "Neural Networks", "Machine Learning"],
    details: [
      "Used Basic U-Net, EAR U-Net, and a custom model built on top of these architectures.",
      "Used Python and TensorFlow/Keras for model development and Flask for the web application.",
      "Trained the model to segment the artery from surrounding ultrasound image tissue.",
      "Built a Flask interface for uploading images, receiving segmented outputs, and downloading results."
    ],
    challenges: "Integrating EAR U-Net with the basic U-Net model due to the significantly different approaches of the two architectures.",
    impact: "Achieved a 93% success rate in segmenting ultrasound images and provided a tool to support faster carotid artery segmentation.",
    githubLink: "https://github.com/NAGARAJ08/Segmentation-Of-The-Transverse-Section-Of-The-Carotid-Artery-using-U-Net"
  },
  {
    id: "segmentation-carotid",
    title: "Segmentation of the Carotid Intima Media in Artery Transversal Images",
    description: "A carotid intima-media segmentation project using image processing techniques and Morphsnakes.",
    skills: ["Python", "Morphsnakes", "Image Processing"],
    details: [
      "Used Python and the Morphsnakes library for image segmentation.",
      "Applied traditional image processing techniques to identify and segment regions within medical images.",
      "Experimented with multiple methodologies to improve segmentation accuracy."
    ],
    challenges: "Some images were difficult to process using Morphsnakes alone, resulting in inconsistent results across the dataset.",
    impact: "Built foundational knowledge in computer vision and image processing for later neural-network-based segmentation work.",
    githubLink: "https://github.com/NAGARAJ08/Ultrasound-Image-Segmentation"
  },
  {
    id: "farmer-dairy",
    title: "Farmer-Friendly Web Application for Milk Collection and Sales Management",
    description: "A web application helping farmers track daily milk collection and sales while streamlining reporting.",
    skills: ["HTML", "CSS", "MySQL", "PHP"],
    details: [
      "Used PHP, MySQL, HTML, CSS, and Bootstrap.",
      "Built a responsive interface for entering daily milk collection and sales data.",
      "Used PHP and MySQL for data storage and processing."
    ],
    challenges: "Designing an efficient data flow and suitable database tables while managing relationships between farmers, collection, and sales.",
    impact: "Improved record-keeping and reduced manual effort for dairy operation management.",
    githubLink: "https://github.com/NAGARAJ08/Dairy-Management-System"
  }
];

export const getProjectById = (id) => {
  return ProjectData.find(project => project.id === id);
};

export const filterProjectsBySkill = (skill) => {
  return ProjectData.filter(project =>
    project.skills.some(projectSkill => projectSkill.toLowerCase().includes(skill.toLowerCase()))
  );
};